import React from 'react'
import { Typography, Avatar as MUIAvatar } from '@mui/material'
import { deepOrange } from '@mui/material/colors'
import { getFirstLetter } from '../utils'
import { useTheme } from '@mui/material/styles'

type AvatarProps = {
  imagePath: string | undefined
  name: string | undefined
  border?: number
  size?: number
}

export const Avatar = ({ imagePath, name = '', border = 0, size = 56 }: AvatarProps) => {
  const { palette } = useTheme()
  return (
    <>
      {imagePath
        ? <MUIAvatar src={imagePath} sx={{ width: size, height: size, border: border ? border : 0, borderColor: palette.primary.main }} variant="circular" onError={() => console.log('Error')} />
        : <MUIAvatar sx={{ bgcolor: 'rgb(250, 89, 62, 0.1)', width: size, height: size, fontWeight: 'bold', zIndex: 1 }} onError={() => console.log('Error 2')}>
          <Typography sx={{ color: deepOrange[500], zIndex: 9, fontSize: size / 2, fontWeight: 500 }}>
            {getFirstLetter(name)}
          </Typography>
        </MUIAvatar>
      }
    </>
  )
}
